// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import * as React from "react";

const QuestionTooltip: React.FC = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 15 15">
            <path
                fill="currentColor"
                fillRule="nonzero"
                d="M7 0a7 7 0 0 0-7 7 7 7 0 0 0 7 7 7 7 0 0 0 7-7 7 7 0 0 0-7-7Zm0 10.938a.864.864 0 0 1-.875-.876A.85.85 0 0 1 7 9.188a.88.88 0 0 1 .875.874.88.88 0 0 1-.875.876Zm1.89-3.883-1.234.765v.055c0 .355-.3.656-.656.656a.665.665 0 0 1-.656-.656v-.438c0-.218.11-.437.328-.574l1.558-.93c.192-.109.301-.3.301-.519 0-.328-.298-.601-.626-.601H6.508a.591.591 0 0 0-.602.601c0 .356-.3.656-.656.656a.665.665 0 0 1-.656-.656c0-1.066.847-1.914 1.89-1.914H7.88c1.116 0 1.964.848 1.964 1.914a1.92 1.92 0 0 1-.955 1.64Z"
            />
        </svg>
    );
};

export default React.memo(QuestionTooltip);
